import { Flex, Spinner, Text } from "@chakra-ui/react";

export function ProcessingText({ status }: { status: string | undefined; }) {
    return (
        <Flex gap={2} align={'center'}>
            {status?.toLowerCase() === "processing" ? [
                <Text>Processing...</Text>,
                <Spinner
                    color='primary.400'
                />] : status
            }
        </Flex>
    )
}